export default [
  {"name": "Afghanistan", "code": "AF", "code2": "AFG", "dialCode": "+93"},
  {"name": "Albania", "code": "AL", "code2": "ALB", "dialCode": "+355"},
  {"name": "Algeria", "code": "DZ", "code2": "DZA", "dialCode": "+213"},
  {"name": "American Samoa", "code": "AS", "code2": "ASM", "dialCode": "+1-684"},
  {"name": "Andorra", "code": "AD", "code2": "AND", "dialCode": "+376"},
  {"name": "Angola", "code": "AO", "code2": "AGO", "dialCode": "+244"},
  {"name": "Anguilla", "code": "AI", "code2": "AIA", "dialCode": "+1-264"},
  {"name": "Antarctica", "code": "AQ", "code2": "ATA", "dialCode": "+672"},
  {"name": "Antigua and Barbuda", "code": "AG", "code2": "ATG", "dialCode": "+1-268"},
  {"name": "Argentina", "code": "AR", "code2": "ARG", "dialCode": "+54"},
  {"name": "Armenia", "code": "AM", "code2": "ARM", "dialCode": "+374"},
  {"name": "Aruba", "code": "AW", "code2": "ABW", "dialCode": "+297"},
  {"name": "Australia", "code": "AU", "code2": "AUS", "dialCode": "+61"},
  {"name": "Austria", "code": "AT", "code2": "AUT", "dialCode": "+43"},
  {"name": "Azerbaijan", "code": "AZ", "code2": "AZE", "dialCode": "+994"},
  {"name": "Bahamas", "code": "BS", "code2": "BHS", "dialCode": "+1-242"},
  {"name": "Bahrain", "code": "BH", "code2": "BHR", "dialCode": "+973"},
  {"name": "Bangladesh", "code": "BD", "code2": "BGD", "dialCode": "+880"},
  {"name": "Barbados", "code": "BB", "code2": "BRB", "dialCode": "+1-246"},
  {"name": "Belarus", "code": "BY", "code2": "BLR", "dialCode": "+375"},
  {"name": "Belgium", "code": "BE", "code2": "BEL", "dialCode": "+32"},
  {"name": "Belize", "code": "BZ", "code2": "BLZ", "dialCode": "+501"},
  {"name": "Benin", "code": "BJ", "code2": "BEN", "dialCode": "+229"},
  {"name": "Bermuda", "code": "BM", "code2": "BMU", "dialCode": "+1-441"},
  {"name": "Bhutan", "code": "BT", "code2": "BTN", "dialCode": "+975"},
  {"name": "Bolivia", "code": "BO", "code2": "BOL", "dialCode": "+591"},
  {"name": "Bosnia and Herzegovina", "code": "BA", "code2": "BIH", "dialCode": "+387"},
  {"name": "Botswana", "code": "BW", "code2": "BWA", "dialCode": "+267"},
  {"name": "Brazil", "code": "BR", "code2": "BRA", "dialCode": "+55"},
  {"name": "British Indian Ocean Territory", "code": "IO", "code2": "IOT", "dialCode": "+246"},
  {"name": "Brunei Darussalam", "code": "BN", "code2": "BRN", "dialCode": "+673"},
  {"name": "Bulgaria", "code": "BG", "code2": "BGR", "dialCode": "+359"},
  {"name": "Burkina Faso", "code": "BF", "code2": "BFA", "dialCode": "+226"},
  {"name": "Burundi", "code": "BI", "code2": "BDI", "dialCode": "+257"},
  {"name": "Cambodia", "code": "KH", "code2": "KHM", "dialCode": "+855"},
  {"name": "Cameroon", "code": "CM", "code2": "CMR", "dialCode": "+237"},
  {"name": "Canada", "code": "CA", "code2": "CAN", "dialCode": "+1"},
  {"name": "Cape Verde", "code": "CV", "code2": "CPV", "dialCode": "+238"},
  {"name": "Cayman Islands", "code": "KY", "code2": "CYM", "dialCode": "+1-345"},
  {"name": "Central African Republic", "code": "CF", "code2": "CAF", "dialCode": "+236"},
  {"name": "Chad", "code": "TD", "code2": "TCD", "dialCode": "+235"},
  {"name": "Chile", "code": "CL", "code2": "CHL", "dialCode": "+56"},
  {"name": "China", "code": "CN", "code2": "CHN", "dialCode": "+86"},
  {"name": "Christmas Island", "code": "CX", "code2": "CXR", "dialCode": "+53"},
  {"name": "Cocos (Keeling) Islands", "code": "CC", "code2": "CCK", "dialCode": "+61"},
  {"name": "Colombia", "code": "CO", "code2": "COL", "dialCode": "+57"},
  {"name": "Comoros", "code": "KM", "code2": "COM", "dialCode": "+269"},
  {"name": "Congo, Democratic Republic of the", "code": "CD", "code2": "COD", "dialCode": "+243"},
  {"name": "Congo?(Brazzaville)", "code": "CG", "code2": "COG", "dialCode": "+242"},
  {"name": "Cook Islands", "code": "CK", "code2": "COK", "dialCode": "+682"},
  {"name": "Costa Rica", "code": "CR", "code2": "CRI", "dialCode": "+506"},
  {"name": "Cote d'Ivoire", "code": "CI", "code2": "CIV", "dialCode": "+225"},
  {"name": "Cuba", "code": "CU", "code2": "CUB", "dialCode": "+53"},
  {"name": "Cyprus", "code": "CY", "code2": "CYP", "dialCode": "+357"},
  {"name": "Czech Republic", "code": "CZ", "code2": "CZE", "dialCode": "+420"},
  {"name": "Denmark", "code": "DK", "code2": "DNK", "dialCode": "+45"},
  {"name": "Djibouti", "code": "DJ", "code2": "DJI", "dialCode": "+253"},
  {"name": "Dominica", "code": "DM", "code2": "DMA", "dialCode": "+1-767"},
  {"name": "Dominican Republic", "code": "DO", "code2": "DOM", "dialCode": "+1-809"},
  {"name": "Ecuador", "code": "EC", "code2": "ECU", "dialCode": "+593"},
  {"name": "Egypt", "code": "EG", "code2": "EGY", "dialCode": "+20"},
  {"name": "El Salvador", "code": "SV", "code2": "SLV", "dialCode": "+503"},
  {"name": "Equatorial Guinea", "code": "GQ", "code2": "GNQ", "dialCode": "+240"},
  {"name": "Eritrea", "code": "ER", "code2": "ERI", "dialCode": "+291"},
  {"name": "Estonia", "code": "EE", "code2": "EST", "dialCode": "+372"},
  {"name": "Ethiopia", "code": "ET", "code2": "ETH", "dialCode": "+251"},
  {"name": "Falkland Islands (Malvinas)", "code": "FK", "code2": "FLK", "dialCode": "+500"},
  {"name": "Faroe Islands", "code": "FO", "code2": "FRO", "dialCode": "+298"},
  {"name": "Fiji", "code": "FJ", "code2": "FJI", "dialCode": "+679"},
  {"name": "Finland", "code": "FI", "code2": "FIN", "dialCode": "+358"},
  {"name": "France", "code": "FR", "code2": "FRA", "dialCode": "+33"},
  {"name": "French Guiana", "code": "GF", "code2": "GUF", "dialCode": "+594"},
  {"name": "French Polynesia", "code": "PF", "code2": "PYF", "dialCode": "+689"},
  {"name": "French Southern Territories", "code": "TF", "code2": "ATF", "dialCode": "+262"},
  {"name": "Gabon", "code": "GA", "code2": "GAB", "dialCode": "+241"},
  {"name": "Gambia", "code": "GM", "code2": "GMB", "dialCode": "+220"},
  {"name": "Georgia", "code": "GE", "code2": "GEO", "dialCode": "+995"},
  {"name": "Germany", "code": "DE", "code2": "DEU", "dialCode": "+49"},
  {"name": "Ghana", "code": "GH", "code2": "GHA", "dialCode": "+233"},
  {"name": "Gibraltar", "code": "GI", "code2": "GIB", "dialCode": "+350"},
  {"name": "Greece", "code": "GR", "code2": "GRC", "dialCode": "+30"},
  {"name": "Greenland", "code": "GL", "code2": "GRL", "dialCode": "+299"},
  {"name": "Grenada", "code": "GD", "code2": "GRD", "dialCode": "+1-473"},
  {"name": "Guadeloupe", "code": "GP", "code2": "GLP", "dialCode": "+590"},
  {"name": "Guam", "code": "GU", "code2": "GUM", "dialCode": "+1-671"},
  {"name": "Guatemala", "code": "GT", "code2": "GTM", "dialCode": "+502"},
  {"name": "Guinea", "code": "GN", "code2": "GIN", "dialCode": "+224"},
  {"name": "Guinea-Bissau", "code": "GW", "code2": "GNB", "dialCode": "+245"},
  {"name": "Guyana", "code": "GY", "code2": "GUY", "dialCode": "+592"},
  {"name": "Haiti", "code": "HT", "code2": "HTI", "dialCode": "+509"},
  {"name": "Heard Island and Mcdonald Islands", "code": "HM", "code2": "HMD", "dialCode": "+672"},
  {"name": "Honduras", "code": "HN", "code2": "HND", "dialCode": "+504"},
  {"name": "Hong Kong, Special Administrative Region of China", "code": "HK", "code2": "HKG", "dialCode": "+852"},
  {"name": "Hrvatska", "code": "HR", "code2": "", "dialCode": "+385"},
  {"name": "Hungary", "code": "HU", "code2": "HUN", "dialCode": "+36"},
  {"name": "Iceland", "code": "IS", "code2": "ISL", "dialCode": "+354"},
  {"name": "India", "code": "IN", "code2": "IND", "dialCode": "+91"},
  {"name": "Indonesia", "code": "ID", "code2": "IDN", "dialCode": "+62"},
  {"name": "Iran, Islamic Republic of", "code": "IR", "code2": "IRN", "dialCode": "+98"},
  {"name": "Iraq", "code": "IQ", "code2": "IRQ", "dialCode": "+964"},
  {"name": "Ireland", "code": "IE", "code2": "IRL", "dialCode": "+353"},
  {"name": "Israel", "code": "IL", "code2": "ISR", "dialCode": "+972"},
  {"name": "Italy", "code": "IT", "code2": "ITA", "dialCode": "+39"},
  {"name": "Jamaica", "code": "JM", "code2": "JAM", "dialCode": "+1-876"},
  {"name": "Japan", "code": "JP", "code2": "JPN", "dialCode": "+81"},
  {"name": "Jordan", "code": "JO", "code2": "JOR", "dialCode": "+962"},
  {"name": "Kazakhstan", "code": "KZ", "code2": "KAZ", "dialCode": "+7"},
  {"name": "Kenya", "code": "KE", "code2": "KEN", "dialCode": "+254"},
  {"name": "Kiribati", "code": "KI", "code2": "KIR", "dialCode": "+686"},
  {"name": "Korea, Democratic People's Republic of", "code": "KP", "code2": "PRK", "dialCode": "+850"},
  {"name": "Korea, Republic of", "code": "KR", "code2": "KOR", "dialCode": "+82"},
  {"name": "Kuwait", "code": "KW", "code2": "KWT", "dialCode": "+965"},
  {"name": "Kyrgyzstan", "code": "KG", "code2": "KGZ", "dialCode": "+996"},
  {"name": "Lao PDR", "code": "LA", "code2": "LAO", "dialCode": "+856"},
  {"name": "Latvia", "code": "LV", "code2": "LVA", "dialCode": "+371"},
  {"name": "Lebanon", "code": "LB", "code2": "LBN", "dialCode": "+961"},
  {"name": "Lesotho", "code": "LS", "code2": "LSO", "dialCode": "+266"},
  {"name": "Liberia", "code": "LR", "code2": "LBR", "dialCode": "+231"},
  {"name": "Libya", "code": "LY", "code2": "LBY", "dialCode": "+218"},
  {"name": "Liechtenstein", "code": "LI", "code2": "LIE", "dialCode": "+423"},
  {"name": "Lithuania", "code": "LT", "code2": "LTU", "dialCode": "+370"},
  {"name": "Luxembourg", "code": "LU", "code2": "LUX", "dialCode": "+352"},
  {"name": "Macao, Special Administrative Region of China", "code": "MO", "code2": "MAC", "dialCode": "+853"},
  {"name": "Macedonia, Republic of", "code": "MK", "code2": "MKD", "dialCode": "+389"},
  {"name": "Madagascar", "code": "MG", "code2": "MDG", "dialCode": "+261"},
  {"name": "Malawi", "code": "MW", "code2": "MWI", "dialCode": "+265"},
  {"name": "Malaysia", "code": "MY", "code2": "MYS", "dialCode": "+60"},
  {"name": "Maldives", "code": "MV", "code2": "MDV", "dialCode": "+960"},
  {"name": "Mali", "code": "ML", "code2": "MLI", "dialCode": "+223"},
  {"name": "Malta", "code": "MT", "code2": "MLT", "dialCode": "+356"},
  {"name": "Marshall Islands", "code": "MH", "code2": "MHL", "dialCode": "+692"},
  {"name": "Martinique", "code": "MQ", "code2": "MTQ", "dialCode": "+596"},
  {"name": "Mauritania", "code": "MR", "code2": "MRT", "dialCode": "+222"},
  {"name": "Mauritius", "code": "MU", "code2": "MUS", "dialCode": "+230"},
  {"name": "Mayotte", "code": "YT", "code2": "MYT", "dialCode": "+269"},
  {"name": "Mexico", "code": "MX", "code2": "MEX", "dialCode": "+52"},
  {"name": "Micronesia, Federated States of", "code": "FM", "code2": "FSM", "dialCode": "+691"},
  {"name": "Moldova", "code": "MD", "code2": "MDA", "dialCode": "+373"},
  {"name": "Monaco", "code": "MC", "code2": "MCO", "dialCode": "+377"},
  {"name": "Mongolia", "code": "MN", "code2": "MNG", "dialCode": "+976"},
  {"name": "Montenegro", "code": "ME", "code2": "MNE", "dialCode": "+382"},
  {"name": "Montserrat", "code": "MS", "code2": "MSR", "dialCode": "+1-664"},
  {"name": "Morocco", "code": "MA", "code2": "MAR", "dialCode": "+212"},
  {"name": "Mozambique", "code": "MZ", "code2": "MOZ", "dialCode": "+258"},
  {"name": "Myanmar", "code": "MM", "code2": "MMR", "dialCode": "+95"},
  {"name": "Namibia", "code": "NA", "code2": "NAM", "dialCode": "+264"},
  {"name": "Nauru", "code": "NR", "code2": "NRU", "dialCode": "+674"},
  {"name": "Nepal", "code": "NP", "code2": "NPL", "dialCode": "+977"},
  {"name": "Netherlands", "code": "NL", "code2": "NLD", "dialCode": "+31"},
  {"name": "Netherlands Antilles", "code": "AN", "code2": "ANT", "dialCode": "+599"},
  {"name": "New Caledonia", "code": "NC", "code2": "NCL", "dialCode": "+687"},
  {"name": "New Zealand", "code": "NZ", "code2": "NZL", "dialCode": "+64"},
  {"name": "Nicaragua", "code": "NI", "code2": "NIC", "dialCode": "+505"},
  {"name": "Niger", "code": "NE", "code2": "NER", "dialCode": "+227"},
  {"name": "Nigeria", "code": "NG", "code2": "NGA", "dialCode": "+234"},
  {"name": "Niue", "code": "NU", "code2": "NIU", "dialCode": "+683"},
  {"name": "Norfolk Island", "code": "NF", "code2": "NFK", "dialCode": "+672"},
  {"name": "Northern Mariana Islands", "code": "MP", "code2": "MNP", "dialCode": "+1-670"},
  {"name": "Norway", "code": "NO", "code2": "NOR", "dialCode": "+47"},
  {"name": "Oman", "code": "OM", "code2": "OMN", "dialCode": "+968"},
  {"name": "Pakistan", "code": "PK", "code2": "PAK", "dialCode": "+92"},
  {"name": "Palau", "code": "PW", "code2": "PLW", "dialCode": "+680"},
  {"name": "Palestinian Territory, Occupied", "code": "PS", "code2": "PSE", "dialCode": "+970"},
  {"name": "Panama", "code": "PA", "code2": "PAN", "dialCode": "+507"},
  {"name": "Papua New Guinea", "code": "PG", "code2": "PNG", "dialCode": "+675"},
  {"name": "Paraguay", "code": "PY", "code2": "PRY", "dialCode": "+595"},
  {"name": "Peru", "code": "PE", "code2": "PER", "dialCode": "+51"},
  {"name": "Philippines", "code": "PH", "code2": "PHL", "dialCode": "+63"},
  {"name": "Pitcairn", "code": "PN", "code2": "PCN", "dialCode": "+64"},
  {"name": "Poland", "code": "PL", "code2": "POL", "dialCode": "+48"},
  {"name": "Portugal", "code": "PT", "code2": "PRT", "dialCode": "+351"},
  {"name": "Puerto Rico", "code": "PR", "code2": "PRI", "dialCode": "+1-787"},
  {"name": "Qatar", "code": "QA", "code2": "QAT", "dialCode": "+974"},
  {"name": "Reunion", "code": "RE", "code2": "REU", "dialCode": "+262"},
  {"name": "Romania", "code": "RO", "code2": "ROU", "dialCode": "+40"},
  {"name": "Russian Federation", "code": "RU", "code2": "RUS", "dialCode": "+7"},
  {"name": "Rwanda", "code": "RW", "code2": "RWA", "dialCode": "+250"},
  {"name": "Saint Helena", "code": "SH", "code2": "SHN", "dialCode": "+290"},
  {"name": "Saint Kitts and Nevis", "code": "KN", "code2": "KNA", "dialCode": "+1-869"},
  {"name": "Saint Lucia", "code": "LC", "code2": "LCA", "dialCode": "+1-758"},
  {"name": "Saint Pierre and Miquelon", "code": "PM", "code2": "SPM", "dialCode": "+508"},
  {"name": "Saint Vincent and Grenadines", "code": "VC", "code2": "VCT", "dialCode": "+1-784"},
  {"name": "Samoa", "code": "WS", "code2": "WSM", "dialCode": "+685"},
  {"name": "San Marino", "code": "SM", "code2": "SMR", "dialCode": "+378"},
  {"name": "Sao Tome and Principe", "code": "ST", "code2": "STP", "dialCode": "+239"},
  {"name": "Saudi Arabia", "code": "SA", "code2": "SAU", "dialCode": "+966"},
  {"name": "Senegal", "code": "SN", "code2": "SEN", "dialCode": "+221"},
  {"name": "Serbia", "code": "RS", "code2": "SRB", "dialCode": "+381"},
  {"name": "Seychelles", "code": "SC", "code2": "SYC", "dialCode": "+248"},
  {"name": "Sierra Leone", "code": "SL", "code2": "SLE", "dialCode": "+232"},
  {"name": "Singapore", "code": "SG", "code2": "SGP", "dialCode": "+65"},
  {"name": "Slovakia", "code": "SK", "code2": "SVK", "dialCode": "+421"},
  {"name": "Slovenia", "code": "SI", "code2": "SVN", "dialCode": "+386"},
  {"name": "Solomon Islands", "code": "SB", "code2": "SLB", "dialCode": "+677"},
  {"name": "Somalia", "code": "SO", "code2": "SOM", "dialCode": "+252"},
  {"name": "South Africa", "code": "ZA", "code2": "ZAF", "dialCode": "+27"},
  {"name": "South Georgia and the South Sandwich Islands", "code": "GS", "code2": "SGS", "dialCode": "+500"},
  {"name": "Spain", "code": "ES", "code2": "ESP", "dialCode": "+34"},
  {"name": "Sri Lanka", "code": "LK", "code2": "LKA", "dialCode": "+94"},
  {"name": "Sudan", "code": "SD", "code2": "SDN", "dialCode": "+249"},
  {"name": "Suriname", "code": "SR", "code2": "SUR", "dialCode": "+597"},
  {"name": "Svalbard and Jan Mayen Islands", "code": "SJ", "code2": "SJM", "dialCode": "+47"},
  {"name": "Swaziland", "code": "SZ", "code2": "SWZ", "dialCode": "+268"},
  {"name": "Sweden", "code": "SE", "code2": "SWE", "dialCode": "+46"},
  {"name": "Switzerland", "code": "CH", "code2": "CHE", "dialCode": "+41"},
  {"name": "Taiwan, Republic of China", "code": "TW", "code2": "TWN", "dialCode": "+886"},
  {"name": "Tajikistan", "code": "TJ", "code2": "TJK", "dialCode": "+992"},
  {"name": "Thailand", "code": "TH", "code2": "THA", "dialCode": "+66"},
  {"name": "Togo", "code": "TG", "code2": "TGO", "dialCode": "+228"},
  {"name": "Tokelau", "code": "TK", "code2": "TKL", "dialCode": "+690"},
  {"name": "Tonga", "code": "TO", "code2": "TON", "dialCode": "+676"},
  {"name": "Trinidad and Tobago", "code": "TT", "code2": "TTO", "dialCode": "+1-868"},
  {"name": "Tunisia", "code": "TN", "code2": "TUN", "dialCode": "+216"},
  {"name": "Turkey", "code": "TR", "code2": "TUR", "dialCode": "+90"},
  {"name": "Turkmenistan", "code": "TM", "code2": "TKM", "dialCode": "+993"},
  {"name": "Turks and Caicos Islands", "code": "TC", "code2": "TCA", "dialCode": "+1-649"},
  {"name": "Tuvalu", "code": "TV", "code2": "TUV", "dialCode": "+688"},
  {"name": "Uganda", "code": "UG", "code2": "UGA", "dialCode": "+256"},
  {"name": "Ukraine", "code": "UA", "code2": "UKR", "dialCode": "+380"},
  {"name": "United Arab Emirates", "code": "AE", "code2": "ARE", "dialCode": "+971"},
  {"name": "United Kingdom", "code": "gb", "code2": "GBR", "dialCode": "+44"},
  {"name": "United States Minor Outlying Islands", "code": "UM", "code2": "UMI", "dialCode": "+246"},
  {"name": "United States of America", "code": "US", "code2": "USA", "dialCode": "+1"},
  {"name": "Uruguay", "code": "UY", "code2": "URY", "dialCode": "+598"},
  {"name": "Uzbekistan", "code": "UZ", "code2": "UZB", "dialCode": "+998"},
  {"name": "Vanuatu", "code": "VU", "code2": "VUT", "dialCode": "+678"},
  {"name": "Venezuela", "code": "VE", "code2": "VEN", "dialCode": "+58"},
  {"name": "Viet Nam", "code": "VN", "code2": "VNM", "dialCode": "+84"},
  {"name": "Virgin Islands, US", "code": "VI", "code2": "VIR", "dialCode": "+1-284"},
  {"name": "Wallis and Futuna Islands", "code": "WF", "code2": "WLF", "dialCode": "+681"},
  {"name": "Western Sahara", "code": "EH", "code2": "ESH", "dialCode": "+212"},
  {"name": "Yemen", "code": "YE", "code2": "YEM", "dialCode": "+967"},
  {"name": "Zambia", "code": "ZM", "code2": "ZMB", "dialCode": "+260"},
  {"name": "Zimbabwe", "code": "ZW", "code2": "ZWE", "dialCode": "+263"}
]